import { apiClient, errorInterceptor, recentRefNoMiddleware, setAppScreen } from '@slot-nx/core'
import gsap from 'gsap'
import { createRoot } from 'react-dom/client'
import { gameConfig } from './config'
import { App } from './components/App'

gsap.defaults({
  ease: 'none',
})

apiClient.interceptors.response.use((response) => {
  recentRefNoMiddleware(response)
  return response
}, errorInterceptor)
setAppScreen(gameConfig.resolution.width, gameConfig.resolution.height)

export const rootElement = document.getElementById('root') as HTMLElement
const root = createRoot(rootElement)
root.render(<App />)
//

// deploy trigger

